import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {ThemeProvider} from '@material-ui/core/styles';
import axios from 'axios';

import './index.css';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import theme from './Theme';
import createStore from './features/store';

axios.defaults.baseURL = 'http://mckim.thingsw.com:3000';
// axios.defaults.baseURL = 'http://192.168.1.124:3000';
// axios.defaults.baseURL = 'http://localhost:3000';
const store = createStore();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
